import React, {Component} from 'react'

import Icon from '../../components/Icon'

import '../../helpers/Array';

class LoadsMore extends Component {

  constructor(props) {
		super(props);
		this.state = {page:1};
	}

	nextPage = () => {

		this.setState({page:this.state.page + 1});
	}

  render () {
  	
  	const {items,perPage} = this.props;

  	let page = this.state.page
  	let pages = Math.ceil(items.length / perPage);

  	let paged = [...items];

  	let end = perPage * page;
  	if(end > items.length) end = items.length;
  	//end -= 1;

  	let paginated = paged.splice(0,end);

  	const output = this.props.render(paginated);

  	const moreLink = (page < pages) ? <div className="Link Link--more" onClick={this.nextPage}>Loads more</div> : null

    return (
    	<div>
    		{output}
    		{moreLink}
    	</div>
    	)
  }
}

export default LoadsMore



// WEBPACK FOOTER //
// ./src/js/components/LoadsMore/LoadsMore.jsx